import React, { useState, useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PATHS from "../../../../constants/paths";
import * as ProductionOrderSapServices from "../../../../services/ProductionOrderSapService";
import { getDateFormatTimeZone } from "../../../../utils/formats";
import {

} from "../../../../constants";
import { useProductionOrderSapExtraInfo } from "../hook/useProductionOrderSapExtraInfo";
import Detail from "./productionOrderSapDetail.view";
import moment from "moment-timezone";
import * as XLSX from "xlsx";

const ProductionOrderSapDetailContainer = ({ uuid }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [forceRefresh, setForceRefresh] = useState(false);

  const refresh = () => {
    setForceRefresh(true);
  };

  const { addExtraInfo } = useProductionOrderSapExtraInfo(refresh);

  useEffect(() => {
    if (forceRefresh) {
      ProductionOrderSapServices.getDetail(uuid).then((order) => {
        setData(order);
      });
      setForceRefresh(false);
    }
  }, [forceRefresh, uuid]);

  useEffect(() => {
    ProductionOrderSapServices.getDetail(uuid).then((order) => {
      setData(order);
    });
  }, [uuid]);

  const goBack = async () => {
    navigate(PATHS.PRODUCTION_ORDER_SAP_LIST);
  };

  const handlerOnExtraInfo = async () => {
    try {
      await addExtraInfo(undefined, data);
    } catch (error) {}
  };

  const handlerExportExcel = async (dataExport) => {
    const dataOrder = dataExport.data;

    const type =
      dataOrder.sapProductionVersion === "0004"
        ? "REPROCESO PARTIDORA"
        : dataOrder.type;
    const notifications = [
      ...dataExport.consumptions,
      ...dataExport.productions,
    ];

    const dataNotifications = notifications.map((item) => {
      return {
        A: item.type === 0 ? "Consumos" : "Producciones",
        B: getDateFormatTimeZone(new Date(), "DD-MM-yyyy"),
        C: item.sapBatch,
        D: item.sapMaterial,
        E: item.sapType,
        F: item.sapQuantityEntry,
      };
    });
    const headers = {
      A: "Tipo",
      B: "Fecha",
      C: "Lote",
      D: "Producto",
      E: "Tipo Mov.",
      F: "Cantidad",
    };

    const summaryRow1 = {
      A: "Fecha producción",
      B: "Fecha creación",
      C: "Orden SAP",
      D: "Código Centro",
      E: "Producto",
      F: "Cantidad",
      G: "Versión",
      H: "Tipo",
      I: "Estado",
      J: "Tiempo operativo máquina",
      K: "Tiempo paradas máquina",
      L: "Tiempo efectivo máquina",
    };

    const summaryRow2 = {
      A: getDateFormatTimeZone(
        new Date(dataOrder.sapStartDate),
        "DD-MM-yyyy HH:mm:ss",
      ),
      B: getDateFormatTimeZone(
        new Date(dataOrder.creationDate),
        "DD-MM-yyyy HH:mm:ss",
      ),
      C: dataOrder.idOrderSap || "-",
      D: dataOrder.sapPlant || "-",
      E: dataOrder.sapProduct || "-",
      F: dataOrder.sapQuantity || "-",
      G: dataOrder.sapProductionVersion || "-",
      H: type || "-",
      I: dataOrder.status || "-",
      J: dataOrder.extraInfo?.sapMachineTime || "-",
      K: dataOrder.extraInfo?.sapMachineStoppedInMinutes || "-",
      L: dataOrder.extraInfo?.sapMachineNetoTimeInMinutes || "-",
    };

    dataNotifications.unshift(summaryRow2);
    dataNotifications.unshift(summaryRow1);
    dataNotifications.splice(2, 0, headers);

    const filename = `Order_SAP_export_${moment(new Date()).format(
      "DDMMyyyyHHmm",
    )}`;
    const sheetName = "Listado de órdenes SAP";
    var ws = XLSX.utils.json_to_sheet(dataNotifications, {
      header: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L"],
      skipHeader: true,
      UTC: true,
      dateNF: "dd-mm-yyyy hh:mm;@",
    });
    // dateNF:'mm/dd/yyyy;@',cellDates:true, raw: true}
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, sheetName);
    XLSX.writeFile(wb, filename + ".xlsx");
  };

  return (
    <Detail
      goBack={goBack}
      handlerOnExtraInfo={handlerOnExtraInfo}
      orderData={data}
      refresh={refresh}
      onExportExcel={handlerExportExcel}
    ></Detail>
  );
};

ProductionOrderSapDetailContainer.propTypes = {};

export default ProductionOrderSapDetailContainer;
